<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form
      v-if="!isSuccess"
      id="login-form"
      class="login-form custom-form"
      novalidate
      @submit.prevent="handleSubmit(onSubmit)"
    >
      <ValidationProvider
        v-slot="{ errors }"
        name="Password"
        rules="required|passwordLength|password"
        mode="lazy"
      >
        <fieldset
          class="login-form__field input__wrap password__wrap set__password__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="password"
            v-model="password"
            :type="passwordType"
            name="password"
            class="login-form__field__input password-has-icon required"
            :class="{
              error: errors.length > 0,
              valid: password.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_NEW_PASSWORD'"
            for="password"
            class="login-form__field__label"
          />
          <a
            class="icon--password fa fa-eye"
            @click="showPassword('passwordType')"
          />
          <div class="error-tooltip__wrap">
            <h4 
              v-t="'INPUT_NEW_PASSWORD_ERROR'"
              class="menu-link text-uppercase error-tooltip__content"
            />
            <p 
              class="description xxs-visible" 
            >
              {{ errors[0] }}
            </p>
          </div>
        </fieldset>
      </ValidationProvider>
      <ValidationProvider
        v-slot="{ errors }"
        name="confirm"
        rules="required|passwordMatch:@Password|passwordLength|password"
        mode="lazy"
      >
        <fieldset
          class="login-form__field input__wrap password__wrap set__password__wrap"
          :class="{ 'error-focus': errors.length > 0 }"
        >
          <input
            id="confirmPassword"
            v-model="confirmPassword"
            :type="confirmPasswordType"
            name="confirmPassword"
            class="login-form__field__input password-has-icon required"
            :class="{
              error: errors.length > 0,
              valid: confirmPassword.length > 0 && errors.length == 0,
            }"
            required
          >
          <label
            v-t="'INPUT_CONFIRM_PASSWORD'"
            for="confirmPassword"
            class="login-form__field__label"
          />
          <a
            class="icon--password fa fa-eye"
            @click="showPassword('confirmPasswordType')"
          />
          <div class="error-tooltip__wrap">
            <h4 
              v-t="'INPUT_NEW_PASSWORD_ERROR'"
              class="menu-link text-uppercase error-tooltip__content"
            />
            <p 
              class="description xxs-visible" 
            >
              {{ errors[0] }}
            </p>
          </div>
        </fieldset>
      </ValidationProvider>
      <fieldset class="login-form__field login-form__field--button">
        <SubmitButton
          :pending="isPending"
        >
          {{ $t('RESET_PASSWORD_BUTTON') }}
        </SubmitButton>
      </fieldset>
      <transition name="backend-error-fade">
        <div
          v-show="showErrorMsg"
          class="text-center p-t-5"
        >
          <p
            class="text-danger"
          >
            {{ actionStatus.error }}
          </p>
        </div>
      </transition>
    </form>
    <div
      v-if="isSuccess"
      class="success-message text-center"
    >
      <h1
        v-t="'PASS_RESET_SUCCESS_TITLE'"
        class="title md-title"
      />
      <p
        v-t="'PASS_RESET_SUCCESS_FIRST_LINE'"
        class="subtitle"
      />
      <a
        v-t="'BACK_LOGIN_LINK'"
        href="#"
        class="button button--transparent-grad pulse m-t-40"
        @click="goToLogin"
      />
    </div>
  </ValidationObserver>
</template>

<script>
import { $ngStateService } from '@/angularBridgeCode/ringbaPortal.servicesModule';
import SubmitButton from '@/modules/auth/components/SubmitButton';
import messages from '../locales';
import { STATUS_ERROR, STATUS_PENDING, STATUS_SUCCESS } from '@/store/helpers';

export default {
  components: {
    SubmitButton
  },
  props: {
    actionStatus: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data: function () {
    return {
      confirmPassword: '',
      confirmPasswordType: 'password',
      password: '',
      passwordType: 'password',
    };
  },
  computed: {
    isPending() {
      return this.actionStatus.status === STATUS_PENDING;
    },
    isSuccess() {
      return this.actionStatus.status === STATUS_SUCCESS;
    },
    showErrorMsg() {
      return this.actionStatus.status === STATUS_ERROR && this.actionStatus.error.length > 0;
    },
  },
  methods: {
    goToLogin() {
      $ngStateService.go('login');
    },
    onSubmit() {
      const { password, confirmPassword } = this;
      this.$emit('reset-password', { password, confirmPassword });
    },
    showPassword(passwordField) {
      if (this[passwordField] === 'password') {
        this[passwordField] = 'text';
      } else {
        this[passwordField] = 'password';
      }
    },
  },
  i18n: {
    messages,
    locale: 'en',
  },
};
</script>

<style>
</style>